import { Translatable } from '@app/types/translatable.type';

const InterviewStatusDisplayOptions: { [key: string]: Translatable } = {
    Pending: 'interviewStatus.pending',
    Overdue: 'interviewStatus.overdue',
    Submitted: 'interviewStatus.submitted',
};

export { InterviewStatusDisplayOptions };
